<template>
  <div>
    <a-alert
      v-if="errorMessage"
      type="error"
      :message="errorMessage"
      banner
      closable
      @close="errorMessage = null"
    />

    <!-- FILTER -->
    <ARow :gutter="[8, 8]">
      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <a-month-picker
          style="width:100%;"
          v-model:value="state.params.month"
          placeholder="Bulan"
          format="MMMM YYYY"
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-salesman
          v-model:value="state.params.salesman"
          placeholder="Pilih Salesman"
          style="width: 100%"
          :mode="null"
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-opco style="width:100%;" v-model:value="state.params.area_ap" />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-province style="width:100%;" v-model:value="state.params.provinsi" />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-area
          style="width:100%;"
          v-model:value="state.params.area"
          v-model:provinsi="state.params.provinsi"
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-kabupaten-kota
          style="width:100%;"
          v-model:value="state.params.kabupaten"
          v-model:area="state.params.area"
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-toko
          style="width: 100%"
          v-model:value="state.params.toko"
          :mode="null"
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <filter-distributor
          style="width:100%;"
          v-model:value="state.params.distributor"
          v-model:area="state.params.area"
          v-model:provinsi="state.params.provinsi"
          v-model:kabupaten="state.params.kabupaten"
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterCustomerPriorityLevel
          style="width:100%;"
          placeholder="Toko Tidak Transaksi"
          :mode="null"
          v-model:value="state.params.tokoTidakTransaksi"/>
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <FilterCustomerPriorityLevel
          style="width:100%;"
          placeholder="Volume Turun"
          :mode="null"
          v-model:value="state.params.volumeTurun"/>
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <a-select
          v-model:value="state.params.tokoVolumeKosong"
          placeholder="Tidak Transaksi > 2x Visit"
          style="width:100%"
          :options="state.filterOptions.status"
          allow-clear
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <a-select
          v-model:value="state.params.tokoSowMinus"
          placeholder="SOW > 50%"
          style="width:100%"
          :options="state.filterOptions.status"
          allow-clear
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <a-select
          v-model:value="state.params.tokoDikomplain"
          placeholder="Komplain > 2x"
          style="width:100%"
          :options="state.filterOptions.status"
          allow-clear
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <a-select
          v-model:value="state.params.avgVolumeProgram"
          placeholder="Volume Program Tidak Tercapai"
          style="width:100%"
          :options="state.filterOptions.status"
          allow-clear
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <a-select
          v-model:value="state.params.tokoTidakDivisit"
          placeholder="Tidak Ada Visit"
          style="width:100%"
          :options="state.filterOptions.status"
          allow-clear
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <a-input-search
          style="width:100%;"
          v-model:value="state.params.q"
          placeholder="Cari ..."
          allow-clear
        />
      </ACol>

      <ACol :xl="6" :md="8" :sm="12" :span="24">
        <a-button
          type="primary"
          @click="btnFetchData"
          :loading="state.isFetching">
          <i class="fa fa-search" v-if="!state.isFetching"></i>
          <span v-else>Memuat Data ...</span>
        </a-button>
      </ACol>
    </ARow>

    <!-- EXPORT EXCEL -->
    <div class="row justify-content-end mt-2">
      <div class="col-lg-6 col-md-12 text-right">
        <a-button
          title="download excel"
          type="primary"
          @click="btnDownloadExcel"
          :loading="state.isDownloading">
          <i class="fa fa-file-excel-o" aria-hidden="true" v-if="!state.isDownloading"></i>
          <span v-else>Downloading ...</span>
        </a-button>
      </div>
    </div>

    <!-- TABLE -->
    <div class="table-responsive text-nowrap mt-4">
      <md-table
        :columns="state.columns"
        :data-source="state.data"
        size="small"
        row-key="id"
        :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :pagination="{
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
          showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} dari ${total} hasil`,
          total: state.meta.total,
          pageSize: state.meta.per_page,
          current: state.meta.page,
        }"
        @change="handleTableChange"
        :loading="state.isFetching"
      >
        <template #no="{ index }">
          <span>
            {{ (state.meta.page - 1) * state.meta.per_page + 1 + index }}
          </span>
        </template>
      </md-table>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from 'vue'
import apiClient from '@/services/axios'
import moment from 'moment'
import { pickBy } from 'lodash'
import FilterOpco from '@/components/filter/FilterOpco'
import FilterDistributor from '@/components/filter/FilterDistributor'
import FilterProvince from '@/components/filter/FilterProvince'
import FilterArea from '@/components/filter/FilterArea'
import FilterKabupatenKota from '@/components/filter/FilterKabupatenKota'
import FilterToko from '@/components/filter/FilterToko'
import FilterSalesman from '@/components/filter/FilterSalesman'
import FilterCustomerPriorityLevel from '@/components/filter/FilterCustomerPriorityLevel'

export default defineComponent({
  components: {
    FilterOpco,
    FilterProvince,
    FilterArea,
    FilterKabupatenKota,
    FilterDistributor,
    FilterToko,
    FilterSalesman,
    FilterCustomerPriorityLevel,
  },

  setup() {
    const errorMessage = ref(null)

    const state = reactive({
      endpoint: '/api/report/customer-priority',
      data: [],
      columns: [
        {
          title: 'NO',
          slots: { customRender: 'no' },
        },
        {
          title: 'Periode',
          dataIndex: 'periode',
        },
        {
          title: 'Kode Toko',
          dataIndex: 'customer_code',
        },
        {
          title: 'Nama Toko',
          dataIndex: 'customer_name',
        },
        {
          title: 'Area AP',
          dataIndex: 'area_ap',
        },
        {
          title: 'Provinsi',
          dataIndex: 'provinsi',
        },
        {
          title: 'Kabupaten/Kota',
          dataIndex: 'kabupaten',
        },
        {
          title: 'Area',
          dataIndex: 'area',
        },
        {
          title: 'Kode Distributor',
          dataIndex: 'vendor_code',
        },
        {
          title: 'Nama Distributor',
          dataIndex: 'vendor_name',
        },
        {
          title: 'Kode Salesman',
          dataIndex: 'salesman_ids',
        },
        {
          title: 'Nama Salesman',
          dataIndex: 'salesman_names',
        },
        {
          title: 'Toko Tidak Transaksi',
          dataIndex: 'toko_tidak_transaksi',
        },
        {
          title: 'Volume turun',
          dataIndex: 'volume_turun',
        },
        {
          title: 'Tidak Transaksi > 2x Visit',
          dataIndex: 'toko_volume_kosong',
        },
        {
          title: 'SOW < 50%',
          dataIndex: 'toko_sow_minus',
        },
        {
          title: 'Komplain > 2x',
          dataIndex: 'toko_dikomplain',
        },
        {
          title: 'Volume Program Tidak Tercapai',
          dataIndex: 'avg_volume_program',
        },
        {
          title: 'Tidak Ada Visit',
          dataIndex: 'toko_tidak_divisit',
        },
      ],
      meta: {
        page: 1,
        per_page: 10,
        total: 0,
      },
      isFetching: false,
      isDownloading: false,
      params: {
        q: '',
        area_ap: [],
        area: [],
        provinsi: [],
        kabupaten: [],
        toko: [],
        distributor: [],
        salesman: [],
        month: moment(new Date()),
        tokoTidakTransaksi: null,
        volumeTurun: null,
        tokoVolumeKosong: null,
        tokoSowMinus: null,
        tokoDikomplain: null,
        avgVolumeProgram: null,
        tokoTidakDivisit: null,
        page: 1,
        'per-page': 10,
      },
      filterOptions: {
        status: [
          { label: 'Yes', value: '3' },
          { label: 'No', value: '0' },
        ],
      },
    })

    const queryParams = () => {
      let params = { ...state.params }

      if (params.month) {
        params.month = moment(params.month).format('YYYY-MM')
      }

      return pickBy(params)
    }

    // fetch list data
    const fetchDataList = () => {
      state.isFetching = true
      errorMessage.value = null

      apiClient
        .get(state.endpoint, {
          params: queryParams(),
        })
        .then(({ data }) => {
          const { items, _meta } = data

          state.data = items
          // ✅ Mapping _meta ke format pagination yang diharapkan
          state.meta.page = _meta.currentPage
          state.meta.per_page = _meta.perPage
          state.meta.total = _meta.totalCount
        })
        .catch((err) => {
          errorMessage.value = 'Gagal mengambil data'
        })
        .finally(() => {
          state.isFetching = false
        })
    }

    const handleTableChange = (page) => {
      state.params.page = page.current
      state.params['per-page'] = page.pageSize
      fetchDataList()
    }

    // download export excel
    const btnDownloadExcel = () => {
      state.isDownloading = true
      apiClient
        .get(state.endpoint, {
          params: {
            ...queryParams(),
            _export: 'xls',
          },
          responseType: 'blob',
        })
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `laporan-toko-prioritas_${moment().format('DDMMYY_HHmm')}.xlsx`,
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(async (error) => {
          errorMessage.value = null
          if (error.response) {
            const { status, statusText } = error.response
            try {
              const message = JSON.parse(await error.response.data.text()).message
              errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
            } catch {
              errorMessage.value = `Kode error ${status}, ${statusText}`
            }
          }
        })
        .finally(() => {
          state.isDownloading = false
        })
    }

    const btnFetchData = () => {
      fetchDataList()
    }

    onMounted(() => {
      btnFetchData()
    })

    return {
      state,
      errorMessage,
      btnFetchData,
      handleTableChange,
      btnDownloadExcel,
    }
  },
})
</script>
